//
import ProductModel from '@/models/Warehouse/WhProduct'

//
import ProductAppends from './appends'
import ProductIncludes from './includes'

/**
 * 
 */
export default async wh_product_id => {
    
    try {
        //
        const response = await ProductModel.append( [ ...ProductAppends ] ).include( ProductIncludes ).find( wh_product_id )
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}
